export const es = {
    confirming: `Confirmando tu cuenta...`,
    status: `Estado de la confirmación`,
    waiting: `Por favor espera mientras confirmamos tu cuenta...`,
    error: `La confirmación de la cuenta falló. Por favor inténtalo de nuevo o contacta al soporte.`,
};
//# sourceMappingURL=es.js.map